<template>
  <v-footer class="tmdb-attribution justify-center" padless>
    <a href="https://www.themoviedb.org" target="_blank" rel="noopener">
      <img src="/tmdb-logo.svg" alt="TMDB" class="tmdb-attribution-logo" />
    </a>
    <span>This website uses TMDB and the TMDB APIs but is not endorsed, certified, or otherwise approved by TMDB.</span>
  </v-footer>
</template>

<script>
export default {
  name: 'TmdbAttribution',
}
</script>

<style scoped>
.tmdb-attribution {
  gap: 8px;
  padding: 8px 12px;
  font-size: 11px;
  opacity: 0.75;
}

.tmdb-attribution-logo {
  display: block;
  height: 12px;
}
</style>
